<template>
  <div>
    <div class="line_loading"><i class="fas fa-spinner fa-spin"></i></div>
  </div>
</template>

<script>
import { GET_OAUTH } from '@/store/line/actions'

export default {
  name: 'LineOAuth',
  data () {
    return {
      c: null,
      redirectUrl: null
    }
  },
  methods: {
    getQueryStrings () {
      try {
        const search = document.location.search.substring(1)
        const params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

        if ('c' in params) {
          this.c = params.c
        }
        if ('redirect_url' in params) {
          this.redirectUrl = params.redirect_url
        }
      } catch (e) {
      }

      this.getLineUrl()
    },
    getLineUrl () {
      this.$store.dispatch(GET_OAUTH, {
        c: this.c,
        redirect_url: this.redirectUrl
      })
        .then((data) => {
          location.href = data.url
        })
        .catch((error) => {
          if (error.errorStatus === 400) {
            location.href = error.errorData.url
          }
        })
    }
  },
  created () {
    this.getQueryStrings()
  }
}
</script>
